import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EButtonType } from "../../../data-types/button.enum";

@Component({
  selector: 'cowing-core-cowing-dialog',
  templateUrl: './cowing-dialog.component.html',
  styleUrls: ['./cowing-dialog.component.scss']
})
export class CowingDialogComponent {
  @Input('isOpen') isOpen = false;
  @Input('tittle') tittle = "";
  @Input('body') body = "";
  @Input() url = "";
  @Output('toggle') toggle: EventEmitter<boolean> = new EventEmitter();
  public EButtonType = EButtonType;

  constructor(
    private _translate: TranslateService
  ) {}

  clickedOutside(e) {
    if (e.target.className === 'modal-wrapper') {
      this.toggle.emit(false);
      this.isOpen = false;
    }
  }

  toggleModal(e) {
    this.isOpen = e;
    this.toggle.emit(e);
  }

  redirectToStore() {
    console.log(this.url);
    window.open(this.url)
  }

  closeDialog() {
    this.toggle.emit(false);
    this.isOpen = false;
  }
}
